import { atom, selector } from 'recoil';
import {
  handleFilterScrollReset,
  updateShopFilterUrlSearchParams,
} from '../../components/Ecommerce/CategoriesShopWithNav/NavForms/Filters/shopWithNavFilters.utils';
import { useEffect } from 'react';
import getDefaultSearchFromUrl from 'utils/globals/getDefaultSearchFromUrl';
import FilterService from '../../services/FilterService';
import { uuid } from 'utils/globals/helpers';

export const collectionSearchLoadingState = atom({
  key: 'collectionSearchLoadingState',
  default: false,
});

export const collectionSearchActiveState = atom({
  key: 'collectionSearchActiveState',
  default: false,
});

export const collectionListState = atom({
  key: 'collectionListState',
  default: [],
});

export const collectionFiltersState = atom({
  key: 'collectionFiltersState',
  default: FilterService.fromURl() as { [key: string]: any },
});

const filterFunctions: [string, (...p: any[]) => boolean][] = [
  [
    'collections',
    (product, mainVariant, variants, collections) =>
      collections.includes(product.collection.title),
  ],
  [
    'shapes',
    (product, mainVariant, variants, shapes) => shapes.includes(product.shape),
  ],
  [
    'colors',
    (product, mainVariant, variants, colors) =>
      variants.find((v) => colors.includes(v.color?.shopifyKey?.toLowerCase())),
  ],
  [
    'ages',
    (product, mainVariant, variants, ages) =>
      ages.includes(mainVariant.size?.value),
  ],
  [
    'promotion',
    (product, mainVariant, variants, promotion) =>
      variants.find((v) =>
        promotion.includes(v.promotion?.discount?.toLowerCase())
      ),
  ],
];

export const collectionFilterListState = selector({
  key: 'collectionFilterListState',
  get: ({ get }) => {
    const id = uuid();
    const filter = get(collectionFiltersState);
    let list = get(collectionListState);

    // unique products list
    const productKeys = {};
    const products = [];
    list.forEach((p) => {
      if (p && !productKeys[p.shopifyKey]) {
        products.push({ ...p, id: `${id}-${p.shopifyKey}` });
        productKeys[p.shopifyKey] = true;
      }
    });

    // Filter function
    return products
      .filter((item, idx) => {
        // Check item has product
        if (!item) {
          return false;
        }

        let variants = [...item.variants];

        let matchFilters = true;
        filterFunctions.forEach(([key, fct]) => {
          if (key in filter && filter[key])
            matchFilters =
              matchFilters &&
              fct(item, item.defaultProductVariant, variants, filter[key]);
        });

        return matchFilters;
      })
      .map((item) => {
        return {
          product: item,
          label: item.label,
        };
      });
  },
});

export const collectionState = selector({
  key: 'collectionState',
  get: ({ get }) => {
    let isActive = false;
    const filter = get(collectionFiltersState);
    const list = get(collectionFilterListState);
    const isLoading = get(collectionSearchLoadingState);

    // updateShopFilterUrlSearchParams(filter);

    Object.keys(filter).forEach((filterInput) => {
      if (filter[filterInput]?.length > 0) {
        isActive = true;
      }
    });

    if (isActive) {
      handleFilterScrollReset();
    }

    return {
      isActive,
      isLoading,
      grid: {
        gridItems: list,
        itemsWidth: 'w-full lg:w-1/3',
      },
    };
  },
});
